import styled from '@emotion/styled';

export const Container = styled.div`
padding-top: 30px;
display:flex;
align-items: center;
flex-direction: column;
`;

export const Title = styled.h2`
margin-bottom: 30px;
text-align: center;
font-family: Quicksand;
font-weight: 700;
font-size: 34px;
color: #86868a;
`;